export default __webpack_public_path__ + "static/media/hand-right-back.39ec69c1.png";